import { Component, inject, Input } from '@angular/core';
import moment from 'moment';
import 'moment/locale/es';
import { CodigoSectores } from '../../../../../_enums/enum';

import { NavService } from '../../../../../_services/_nav.service';

@Component({
  selector: 'app-perfil-crezcamos-endeudamiento-consulta',
  templateUrl: './perfil-crezcamos-endeudamiento-consulta.component.html',
  styleUrls: ['./perfil-crezcamos-endeudamiento-consulta.component.scss']
})
export class PerfilCrezcamosEndeudamientoConsultaComponent { 
  @Input() informacionPerfil: any;
  carTabla = false;
  listaEndeudamientoObligaciones: any[] = [];
  loadTable: boolean = false;
  columnasClasPasivosSaldos: any[] = [];
  listaObligacionesCanceladasAcumulado: any[] = [];
  numeroRegistrosObligaciones = 0;
  columnasObligaciones: any[] = [];
  registrosEndeudamiento: any[] = [];
  public banMsgError: Boolean = false;

  private navService = inject( NavService );

  async ngOnInit() {
    this.carTabla = true;
    if ( this.informacionPerfil && this.informacionPerfil.endeudamientoUltimaConsulta && this.informacionPerfil.endeudamientoUltimaConsulta.mensaje) {
      this.banMsgError = true;
      this.carTabla = false;
      return;
  }
    this.registrosEndeudamiento.push(this.informacionPerfil.endeudamientoUltimaConsulta); 
    this.columnasClasPasivosSaldos = [
      { field: 'cantidad', header: this.navService.buscarMensaje( 'FLUJOPROCESOCLASPASIVOSSALDOS.LBL_CANTIDAD' ), sort: false, clase: 'text-center' },
      { field: 'cuota', header: this.navService.buscarMensaje( 'FLUJOPROCESOCLASPASIVOSSALDOS.LBL_CUOTA' ), sort: false,  clase: 'text-center'},
      { field: 'moraMax', header: this.navService.buscarMensaje( 'FLUJOPROCESOCLASPASIVOSSALDOS.LBL_MORAMAX' ), sort: false, clase: 'text-center'  },
      { field: 'saldo', header: this.navService.buscarMensaje( 'FLUJOPROCESOCLASPASIVOSSALDOS.LBL_SALDO' ), sort: false, clase: 'text-center border-right-green' }
    ];
    this.columnasObligaciones = [
      { field: 'cantidad', header: this.navService.buscarMensaje( 'FLUJOPROCESOCLASPASIVOSSALDOS.LBL_CANTIDAD' ), sort: false, clase: 'text-center not-radius not-background' },
      { field: 'cuota', header: this.navService.buscarMensaje( 'FLUJOPROCESOCLASPASIVOSSALDOS.LBL_CUOTA' ), sort: false,  clase: 'text-center'},
      { field: 'moraMax', header: this.navService.buscarMensaje( 'FLUJOPROCESOCLASPASIVOSSALDOS.LBL_MORAMAX' ), sort: false, clase: 'text-center border-right-green not-radius'  },
    ];  
    this.cargarInformacionObligaciones();  
    this.carTabla = false;
  }

  cargarInformacionObligaciones() {
    this.loadTable = true;
    this.listaEndeudamientoObligaciones = [];
    const listaTemporal = [];
    const ordenObligaciones = ['obligacionesAlDia','obligacionesMora', 'obligacionesCanceladas'];
    const listaMoraMax = [];
    this.registrosEndeudamiento.forEach(x => {
      if (x.endeudamientoActual) {
        ordenObligaciones.forEach(obl => {
          ['titular', 'deudor', 'codeudor'].forEach(clf => {
            if (Array.isArray(x.endeudamientoActual[obl][clf])) {
              const listaOrdenadaXSector = this.ordenarListasXSector(x.endeudamientoActual[obl][clf], );
              listaOrdenadaXSector.forEach(r => {
                if (obl === 'obligacionesCanceladas' && !r.indicadorMoraVigente) {
                  return;
                }
                r.tipoObligacion = obl;
                r.clasificacion = clf;
                listaTemporal.push(r);
              });
            }

          });
        });
      }
    });

    listaTemporal.forEach(v => {
      const indexItem = this.listaEndeudamientoObligaciones.findIndex(f => f.tipoObligacion === v.tipoObligacion);
      if (indexItem === -1) {
        const objObligacion = Object.assign({});
        objObligacion.tipoObligacion = v.tipoObligacion;
        objObligacion.detalle = [];
        switch (v.clasificacion) {
          case 'titular':
            objObligacion.detalle.push(
              {
                sector: v.sector,
                codigoSector: v.codigoSector,
                titular: {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente},
                deudorSolidario: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                codeudor: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                total: v.saldo
              }
            );
            break;
          case 'deudor':
            objObligacion.detalle.push(
              {
                sector: v.sector,
                codigoSector: v.codigoSector,
                titular: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                deudorSolidario: {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente},
                codeudor: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                total: v.saldo
              }
            );
            break;

          case 'codeudor':
            objObligacion.detalle.push(
              {
                sector: v.sector,
                codigoSector: v.codigoSector,
                titular: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                deudorSolidario: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                codeudor: {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente},
                total: v.saldo
              }
            );
            break;
          default:
            break;

        }
        this.listaEndeudamientoObligaciones.push(objObligacion);
      } else {
        const indexSector = this.listaEndeudamientoObligaciones[indexItem].detalle.findIndex(s => s.codigoSector === v.codigoSector);

        if (indexSector === -1) {
          switch (v.clasificacion) {
            case 'titular':
              this.listaEndeudamientoObligaciones[indexItem].detalle.push(
                {
                  sector: v.sector,
                  codigoSector: v.codigoSector,
                  titular: {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente},
                  deudorSolidario: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                  codeudor: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                  total: v.saldo
                }
              );
              break;
            case 'deudor':
              this.listaEndeudamientoObligaciones[indexItem].detalle.push(
                {
                  sector: v.sector,
                  codigoSector: v.codigoSector,
                  titular: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                  deudorSolidario: {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente},
                  codeudor: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                  total: v.saldo
                }
              );
              break;
            case 'codeudor':
              this.listaEndeudamientoObligaciones[indexItem].detalle.push(
                {
                  sector: v.sector,
                  codigoSector: v.codigoSector,
                  titular: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                  deudorSolidario: {cantidad: 0, cuota: 0, moraMax: 0, saldo: 0, indicadorMoraMax: false},
                  codeudor: {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente},
                  total: v.saldo
                }
              );
              break;
            default:
              break;

          }
        } else {
          switch (v.clasificacion) {
            case 'titular':
              this.listaEndeudamientoObligaciones[indexItem].detalle[indexSector].titular = {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente};
              break;
            case 'deudor':
              this.listaEndeudamientoObligaciones[indexItem].detalle[indexSector].deudorSolidario = {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente};
              break;

            case 'codeudor':
              this.listaEndeudamientoObligaciones[indexItem].detalle[indexSector].codeudor = {cantidad: v.cantidad, cuota: v.cuota, moraMax: v.moraMaxima, saldo: v.saldo, indicadorMoraMax: v.indicadorMoraVigente};
              break;
            default:
              break;
          }
          this.listaEndeudamientoObligaciones[indexItem].detalle[indexSector].total += v.saldo;
        }
      }
    });
    
    ['obligacionesAlDia','obligacionesMora'].forEach(o => {
      const existeItem = this.listaEndeudamientoObligaciones.find(t => t.tipoObligacion === o );
      if (!existeItem) {
          const objObligacion = Object.assign({});
          objObligacion.tipoObligacion = o ;
          objObligacion.detalle = [];
          this.listaEndeudamientoObligaciones.push(objObligacion);
      }
    });

    /*Totales*/
    let totalEndeudamientoTitularCantidad = 0;
    let totalEndeudamientoTitularCuota = 0;
    let totalEndeudamientoTitularSaldo = 0;
    let totalEndeudamiento = 0;
    let indicadorEndeudamientoTitularMoraMax = false;

    let totalEndeudamientoDeudorCantidad = 0;
    let totalEndeudamientoDeudorCuota = 0;
    let totalEndeudamientoDeudorSaldo = 0;
    let indicadorEndeudamientoDeudorMoraMax = false;

    let totalEndeudamientoCodeudorCantidad = 0;
    let totalEndeudamientoCodeudorCuota = 0;
    let totalEndeudamientoCodeudorSaldo = 0;
    let indicadorEndeudamientoCodeudorMoraMax = false;

    let endeudamientoTitularMoraMax = 0;
    let endeudamientoDeudorMoraMax = 0;
    let endeudamientoCodeudorMoraMax = 0;

    /*Cantidad canceladas Mora Vigente*/
    let totalTitularCantidadCanceladas = 0;
    let totalDeudorCantidadCanceladas = 0;
    let totalCodeudorCantidadCanceladas = 0;

    ordenObligaciones.forEach(obl => {
      const indice =  this.listaEndeudamientoObligaciones.findIndex(l => l.tipoObligacion === obl);
      let indiceRegistroAgregado = 0;
      if (indice !== -1) {
        const objObligacionTotal = Object.assign({});
        objObligacionTotal.tipoObligacion = 'total' + obl ;
        objObligacionTotal.registros = false;
        objObligacionTotal.detalle = [
          {
            titulo: obl === 'obligacionesAlDia'
              ? 'TOTAL AL DIA'
              : obl === 'obligacionesMora'
                ? 'TOTAL MORA'
                : obl === 'obligacionesCanceladas'
                  ? 'OBLIGACIONES CANCELADAS'
                  : null,
            titular: {cantidad: '-', cuota: '-', moraMax: '-', saldo: '-', indicadorMoraMax: false},
            deudorSolidario: {cantidad: '-', cuota: '-', moraMax: '-', saldo: '-', indicadorMoraMax: false},
            codeudor: {cantidad: '-', cuota: '-', moraMax: '-', saldo: '-', indicadorMoraMax: false},
            total: '-'
          }
        ];
        indiceRegistroAgregado = indice + 1;
        this.listaEndeudamientoObligaciones.splice(indiceRegistroAgregado, 0, objObligacionTotal );

      }
      let totalTitularCantidad = 0;
      let totalTitularCuota = 0;
      let totalTitularSaldo = 0;
      let total = 0;
      let indicadorTitularMoraMax = false;

      let totalDeudorCantidad = 0;
      let totalDeudorCuota = 0;
      let totalDeudorSaldo = 0;
      let indicadorDeudorMoraMax = false;

      let totalCodeudorCantidad = 0;
      let totalCodeudorCuota = 0;
      let totalCodeudorSaldo = 0;
      let indicadorCodeudorMoraMax = false;

      this.listaEndeudamientoObligaciones.forEach(x => {
        if (x.tipoObligacion === obl) {
          let titularMoraMax = 0;
          let deudorMoraMax = 0;
          let codeudorMoraMax = 0;
          x.detalle.forEach((registro) => {
            titularMoraMax = Math.max(titularMoraMax, registro.titular.moraMax);
            deudorMoraMax = Math.max(deudorMoraMax, registro.deudorSolidario.moraMax);
            codeudorMoraMax = Math.max(codeudorMoraMax, registro.codeudor.moraMax);
          });
          if (obl === 'obligacionesAlDia' || obl === 'obligacionesMora') {
              listaMoraMax.push({titularMoraMax: titularMoraMax, deudorMoraMax: deudorMoraMax, codeudorMoraMax: codeudorMoraMax });
          }
            x.detalle.forEach(t => {

              if (obl === 'obligacionesCanceladas') {
                if (t.titular && t.titular.indicadorMoraMax) {
                  totalTitularCantidadCanceladas ++;
                }

                if (t.deudorSolidario && t.deudorSolidario.indicadorMoraMax) {
                  totalDeudorCantidadCanceladas ++;

                }

                if (t.codeudor && t.codeudor.indicadorMoraMax ) {
                    totalCodeudorCantidadCanceladas ++;
                }
              }
              this.listaEndeudamientoObligaciones[indiceRegistroAgregado].registro = true;
              totalTitularCantidad += t.titular.cantidad;
              totalTitularCuota += t.titular.cuota;
              totalTitularSaldo += t.titular.saldo;
              total += t.total;
              if (t.titular.indicadorMoraMax) {
                indicadorTitularMoraMax = true;
              }

              this.listaEndeudamientoObligaciones[indiceRegistroAgregado].detalle[0].titular = {cantidad: totalTitularCantidad, cuota: totalTitularCuota, moraMax: titularMoraMax, saldo: totalTitularSaldo, indicadorMoraMax: indicadorTitularMoraMax};

              totalDeudorCantidad += t.deudorSolidario.cantidad;
              totalDeudorCuota += t.deudorSolidario.cuota;
              totalDeudorSaldo += t.deudorSolidario.saldo;
              if (t.deudorSolidario.indicadorMoraMax) {
                indicadorDeudorMoraMax = true;
              }
              this.listaEndeudamientoObligaciones[indiceRegistroAgregado].detalle[0].deudorSolidario = {cantidad: totalDeudorCantidad, cuota: totalDeudorCuota, moraMax: deudorMoraMax, saldo: totalDeudorSaldo, indicadorMoraMax: indicadorDeudorMoraMax};

              totalCodeudorCantidad += t.codeudor.cantidad;
              totalCodeudorCuota += t.codeudor.cuota;
              totalCodeudorSaldo += t.codeudor.saldo;
              if (t.codeudor.indicadorMoraMax) {
                indicadorCodeudorMoraMax = true;
              }
              this.listaEndeudamientoObligaciones[indiceRegistroAgregado].detalle[0].codeudor = {cantidad: totalCodeudorCantidad, cuota: totalCodeudorCuota, moraMax: codeudorMoraMax, saldo: totalCodeudorSaldo, indicadorMoraMax: indicadorCodeudorMoraMax};
              this.listaEndeudamientoObligaciones[indiceRegistroAgregado].detalle[0].total = total;
            });

          if (x.tipoObligacion !== 'obligacionesCanceladas') {
            totalEndeudamientoTitularCantidad += totalTitularCantidad;
            totalEndeudamientoTitularCuota +=    totalTitularCuota;
            totalEndeudamientoTitularSaldo +=    totalTitularSaldo;
            totalEndeudamiento +=    total;
            indicadorEndeudamientoTitularMoraMax = indicadorEndeudamientoTitularMoraMax ? indicadorEndeudamientoTitularMoraMax : indicadorTitularMoraMax;;

            totalEndeudamientoDeudorCantidad += totalDeudorCantidad;
            totalEndeudamientoDeudorCuota +=    totalDeudorCuota;
            totalEndeudamientoDeudorSaldo +=    totalDeudorSaldo;
            indicadorEndeudamientoDeudorMoraMax = indicadorEndeudamientoDeudorMoraMax ? indicadorEndeudamientoDeudorMoraMax : indicadorDeudorMoraMax;

            totalEndeudamientoCodeudorCantidad += totalCodeudorCantidad;
            totalEndeudamientoCodeudorCuota +=    totalCodeudorCuota;
            totalEndeudamientoCodeudorSaldo +=    totalCodeudorSaldo;
            indicadorEndeudamientoCodeudorMoraMax = indicadorEndeudamientoCodeudorMoraMax ? indicadorEndeudamientoCodeudorMoraMax : indicadorCodeudorMoraMax;
          }
        }
      });
    });

    listaMoraMax.forEach((reg) => {
      endeudamientoTitularMoraMax = Math.max(endeudamientoTitularMoraMax, reg.titularMoraMax);
      endeudamientoDeudorMoraMax = Math.max(endeudamientoDeudorMoraMax, reg.deudorMoraMax);
      endeudamientoCodeudorMoraMax = Math.max(endeudamientoCodeudorMoraMax, reg.codeudorMoraMax);
    });
    const objObligacionEndeudamiento = Object.assign({});
    objObligacionEndeudamiento.tipoObligacion = 'totalEndeudamiento' ;
    if (totalEndeudamientoTitularCantidad === 0 && totalEndeudamientoTitularCuota === 0
      && totalEndeudamientoTitularSaldo === 0 && totalEndeudamientoCodeudorCantidad === 0 && totalEndeudamientoCodeudorCuota === 0
      && totalEndeudamientoCodeudorSaldo === 0 && totalEndeudamientoDeudorCantidad === 0 && totalEndeudamientoDeudorCuota === 0
      && totalEndeudamientoDeudorSaldo === 0) {

      objObligacionEndeudamiento.detalle = [
        {
          titulo: 'TOTAL ENDEU.',
          titular: {cantidad: '-', cuota: '-', moraMax: '-', saldo: '-', indicadorMoraMax: indicadorEndeudamientoTitularMoraMax},
          deudorSolidario: {cantidad: '-', cuota: '-', moraMax: '-', saldo: '-', indicadorMoraMax: indicadorEndeudamientoDeudorMoraMax},
          codeudor: {cantidad: '-', cuota: '-', moraMax: '-', saldo: '-',  indicadorMoraMax: indicadorEndeudamientoCodeudorMoraMax},
          total: '-'
        }
      ];
    } else {
      objObligacionEndeudamiento.detalle = [
        {
          titulo: 'TOTAL ENDEU.',
          titular: {cantidad: totalEndeudamientoTitularCantidad, cuota: totalEndeudamientoTitularCuota, moraMax: endeudamientoTitularMoraMax, saldo: totalEndeudamientoTitularSaldo, indicadorMoraMax: indicadorEndeudamientoTitularMoraMax},
          deudorSolidario: {cantidad: totalEndeudamientoDeudorCantidad, cuota: totalEndeudamientoDeudorCuota, moraMax: endeudamientoDeudorMoraMax, saldo: totalEndeudamientoDeudorSaldo, indicadorMoraMax: indicadorEndeudamientoDeudorMoraMax},
          codeudor: {cantidad: totalEndeudamientoCodeudorCantidad, cuota: totalEndeudamientoCodeudorCuota, moraMax: endeudamientoCodeudorMoraMax, saldo: totalEndeudamientoCodeudorSaldo, indicadorMoraMax: indicadorEndeudamientoCodeudorMoraMax},
          total: totalEndeudamiento
        }
      ];
    }

    this.listaEndeudamientoObligaciones.push(objObligacionEndeudamiento);
    const acumuladoObligaciones = this.listaEndeudamientoObligaciones.find(x => x.tipoObligacion === 'totalobligacionesCanceladas');
    if (acumuladoObligaciones) {
       if (acumuladoObligaciones.detalle.length > 0) {
         acumuladoObligaciones.detalle[0].titular.cantidad = totalTitularCantidadCanceladas;
         acumuladoObligaciones.detalle[0].deudorSolidario.cantidad = totalDeudorCantidadCanceladas;
         acumuladoObligaciones.detalle[0].codeudor.cantidad = totalCodeudorCantidadCanceladas;
          this.listaObligacionesCanceladasAcumulado.push(acumuladoObligaciones);
       }
    }
    this.numeroRegistrosObligaciones = this.listaObligacionesCanceladasAcumulado.length + 2;
    const ordenRegistros =  ['obligacionesAlDia', 'totalobligacionesAlDia', 'obligacionesMora', 'totalobligacionesMora','totalEndeudamiento', 'obligacionesCanceladas', 'totalobligacionesCanceladas'];
    this.listaEndeudamientoObligaciones = this.listaEndeudamientoObligaciones.sort( function( a: any, b: any ) {
       return  ordenRegistros.indexOf(a.tipoObligacion) - ordenRegistros.indexOf(b.tipoObligacion);
    });
    this.listaEndeudamientoObligaciones.forEach(x => {
      if (x.detalle.length > 0 ) {
          x.detalle.forEach(l => {
            if (l.titular) {
              if (l.titular.cantidad === 0  && l.titular.cuota === 0 && l.titular.saldo === 0) {
                l.titular.cantidad = '-';
                l.titular.cuota = '-';
                l.titular.saldo = '-';
                l.titular.moraMax = '-';
              }
            }
            if (l.deudorSolidario) {
              if (l.deudorSolidario.cantidad === 0  && l.deudorSolidario.cuota === 0 && l.deudorSolidario.saldo === 0) {
                l.deudorSolidario.cantidad = '-';
                l.deudorSolidario.cuota = '-';
                l.deudorSolidario.saldo = '-';
                l.deudorSolidario.moraMax = '-';
              }
            }
            if (l.codeudor) {
              if (l.codeudor.cantidad === 0  && l.codeudor.cuota === 0 && l.codeudor.saldo === 0) {
                l.codeudor.cantidad = '-';
                l.codeudor.cuota = '-';
                l.codeudor.saldo = '-';
                l.codeudor.moraMax = '-';
              }
            }
          });
      }
    });
    this.loadTable = false;
  }

  ordenarXFecha(lista: any) {
    return lista.sort( ( a, b ) => {
      const fechaA = moment(a.fechaApertura).valueOf();
      const fechaB = moment(b.fechaApertura).valueOf();
      return fechaA - fechaB;
    } );
}

  ordenarListasXSector(lista: any) {
    let ordenSectores = [];
    ordenSectores =  Object.values( CodigoSectores);
   return  lista.sort( function( a: any, b: any ) {
      return ordenSectores.indexOf(a.codigoSector) - ordenSectores.indexOf(b.codigoSector);
    } );
  }

  retornarTitulosColumnas(nombreListaColumnas: any) {
    return [...nombreListaColumnas, ...nombreListaColumnas, ...nombreListaColumnas];
  }

  formatCurrency(value: any): string {
    if (value < 0) {
      const separadorMiles = '.';
      let numero = Math.abs(value).toString();
      let resultado = '';
  
      if (numero.indexOf('.') !== -1) {
        numero = numero.split('.')[0];
      }
  
      for (let i = numero.length - 1, j = 0; i >= 0; i--, j++) {
        resultado = numero.charAt(i) + (j > 0 && j % 3 === 0 ? separadorMiles : '') + resultado;
      }
  
      if (value < 0) {
        resultado = '$-' + resultado;
      }
  
      return resultado;
    }    
    if (value === 0) {
      return '$0';
    }
    if (value === null || value === '-') {
      return '-';      
    }
    if (value < 1000) {
      return '$0.' + value.toLocaleString('en-US', {
        minimumIntegerDigits: 3,
        useGrouping: false 
      }).replace(',', '.'); // Reemplaza coma con punto
    }
    return '$' + (value / 1000).toLocaleString('en-US', { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 0 
    }).replace(',', '.'); // Reemplaza coma con punto
  }
  
}
